import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

const Terms = () => {
  return (
    <>
      <Helmet>
        <title>Terms of Service - Ursus Victor LLC</title>
        <meta name="description" content="Terms of Service for Ursus Victor LLC. Read our terms and conditions for using our loan application support services." />
      </Helmet>

      <section style={{
        background: 'linear-gradient(135deg, #1e40af 0%, #3b82f6 100%)',
        color: 'white',
        padding: '4rem 2rem',
        textAlign: 'center'
      }}>
        <div style={{maxWidth: '800px', margin: '0 auto'}}>
          <h1 style={{fontSize: '2.5rem', fontWeight: '800', marginBottom: '1rem'}}>
            Terms of Service
          </h1>
          <p style={{fontSize: '1.1rem', opacity: 0.95}}>
            Last Updated: December 4, 2024
          </p>
        </div>
      </section>

      <section style={{padding: '4rem 2rem', background: 'white'}}>
        <div style={{maxWidth: '900px', margin: '0 auto'}}>
          <div style={{marginBottom: '3rem'}}>
            <h2 style={{fontSize: '1.8rem', fontWeight: '700', color: '#1e40af', marginBottom: '1rem'}}>
              1. Acceptance of Terms
            </h2>
            <p style={{fontSize: '1rem', color: '#4b5563', lineHeight: '1.8'}}>
              By accessing or using the services of Ursus Victor LLC ("Company," "we," "our," or "us"), 
              you agree to be bound by these Terms of Service. If you do not agree to these terms, please do not 
              use our services.
            </p>
          </div>

          <div style={{marginBottom: '3rem'}}>
            <h2 style={{fontSize: '1.8rem', fontWeight: '700', color: '#1e40af', marginBottom: '1rem'}}>
              2. Description of Services
            </h2>
            <p style={{fontSize: '1rem', color: '#4b5563', lineHeight: '1.8', marginBottom: '1rem'}}>
              Ursus Victor LLC provides loan application support and documentation services, including:
            </p>
            <ul style={{fontSize: '1rem', color: '#4b5563', lineHeight: '1.8', paddingLeft: '2rem'}}>
              <li>Loan application preparation and completion assistance</li>
              <li>Financial documentation organization and preparation</li>
              <li>Application review and verification services</li>
              <li>Document checklist creation and guidance</li>
              <li>Application submission preparation support</li>
            </ul>
          </div>

          <div style={{marginBottom: '3rem'}}>
            <h2 style={{fontSize: '1.8rem', fontWeight: '700', color: '#1e40af', marginBottom: '1rem'}}>
              3. Age Requirement
            </h2>
            <p style={{fontSize: '1rem', color: '#4b5563', lineHeight: '1.8'}}>
              You must be at least 18 years of age to use our services, submit information through our website, or receive 
              SMS communications from us. By using our services, you represent and warrant that you are at least 18 years old 
              and have the legal capacity to enter into this agreement. We do not knowingly provide services to minors.
            </p>
          </div>

          <div style={{
            background: '#fef3c7',
            padding: '2rem',
            borderRadius: '12px',
            border: '2px solid #f59e0b',
            marginBottom: '3rem'
          }}>
            <h3 style={{fontSize: '1.3rem', fontWeight: '700', color: '#92400e', marginBottom: '1rem'}}>
              ⚠️ Important Disclosure
            </h3>
            <p style={{fontSize: '1rem', color: '#78350f', lineHeight: '1.7'}}>
              <strong>WE ARE NOT A LENDER.</strong> Ursus Victor LLC is a support services company that provides 
              application assistance only. We do NOT issue loans, make lending decisions, or guarantee funding approval. 
              All financing is provided by third-party financial institutions. We act solely as a support service 
              to help you prepare loan applications.
            </p>
          </div>

          <div style={{marginBottom: '3rem'}}>
            <h2 style={{fontSize: '1.8rem', fontWeight: '700', color: '#1e40af', marginBottom: '1rem'}}>
              4. No Guarantee of Funding
            </h2>
            <p style={{fontSize: '1rem', color: '#4b5563', lineHeight: '1.8'}}>
              We do not guarantee that you will receive funding or be approved for any loan or financing product. 
              Approval decisions, loan terms, interest rates, and all other lending conditions are determined solely 
              by the financial institutions we connect you with. Our services are limited to consultation, preparation, 
              and facilitation.
            </p>
          </div>

          <div style={{marginBottom: '3rem'}}>
            <h2 style={{fontSize: '1.8rem', fontWeight: '700', color: '#1e40af', marginBottom: '1rem'}}>
              5. User Responsibilities
            </h2>
            <p style={{fontSize: '1rem', color: '#4b5563', lineHeight: '1.8', marginBottom: '1rem'}}>
              When using our services, you agree to:
            </p>
            <ul style={{fontSize: '1rem', color: '#4b5563', lineHeight: '1.8', paddingLeft: '2rem'}}>
              <li>Provide accurate, complete, and truthful information</li>
              <li>Maintain the confidentiality of any account credentials</li>
              <li>Comply with all applicable laws and regulations</li>
              <li>Not misrepresent your business or financial situation</li>
              <li>Respond promptly to requests for information or documentation</li>
              <li>Review and understand all terms provided by lenders before accepting any offers</li>
            </ul>
          </div>

          <div style={{marginBottom: '3rem'}}>
            <h2 style={{fontSize: '1.8rem', fontWeight: '700', color: '#1e40af', marginBottom: '1rem'}}>
              6. Fees and Payment
            </h2>
            <p style={{fontSize: '1rem', color: '#4b5563', lineHeight: '1.8'}}>
              Our application support fees, if any, will be clearly disclosed before you engage our services. We may receive 
              compensation from financial institutions for successful referrals. Any fees charged by lenders are separate 
              from our support fees and are determined by the lender.
            </p>
          </div>

          <div style={{marginBottom: '3rem'}}>
            <h2 style={{fontSize: '1.8rem', fontWeight: '700', color: '#1e40af', marginBottom: '1rem'}}>
              7. Intellectual Property
            </h2>
            <p style={{fontSize: '1rem', color: '#4b5563', lineHeight: '1.8'}}>
              All content on our website, including text, graphics, logos, and software, is the property of Ursus 
              Victor LLC and is protected by copyright and other intellectual property laws. You may not 
              reproduce, distribute, or create derivative works without our express written permission.
            </p>
          </div>

          <div style={{marginBottom: '3rem'}}>
            <h2 style={{fontSize: '1.8rem', fontWeight: '700', color: '#1e40af', marginBottom: '1rem'}}>
              8. Limitation of Liability
            </h2>
            <p style={{fontSize: '1rem', color: '#4b5563', lineHeight: '1.8'}}>
              To the fullest extent permitted by law, Ursus Victor LLC shall not be liable for any indirect, 
              incidental, special, consequential, or punitive damages, including loss of profits, revenue, data, or 
              business opportunities, arising from your use of our services or inability to obtain funding. Our total 
              liability shall not exceed the amount you paid for our services in the twelve (12) months preceding the claim.
            </p>
          </div>

          <div style={{marginBottom: '3rem'}}>
            <h2 style={{fontSize: '1.8rem', fontWeight: '700', color: '#1e40af', marginBottom: '1rem'}}>
              9. Disclaimer of Warranties
            </h2>
            <p style={{fontSize: '1rem', color: '#4b5563', lineHeight: '1.8'}}>
              Our services are provided "as is" and "as available" without warranties of any kind, either express or 
              implied. We do not warrant that our services will be uninterrupted, error-free, or that any information 
              provided will result in funding approval.
            </p>
          </div>

          <div style={{marginBottom: '3rem'}}>
            <h2 style={{fontSize: '1.8rem', fontWeight: '700', color: '#1e40af', marginBottom: '1rem'}}>
              10. Third-Party Relationships
            </h2>
            <p style={{fontSize: '1rem', color: '#4b5563', lineHeight: '1.8'}}>
              We work with third-party financial institutions and lenders. We are not responsible for their actions, 
              decisions, terms, or services. Any agreements you enter into with lenders are separate contracts between 
              you and the lender. We encourage you to carefully review all terms before accepting any financing offers.
            </p>
          </div>

          <div style={{marginBottom: '3rem'}}>
            <h2 style={{fontSize: '1.8rem', fontWeight: '700', color: '#1e40af', marginBottom: '1rem'}}>
              11. Privacy and Data Protection
            </h2>
            <p style={{fontSize: '1rem', color: '#4b5563', lineHeight: '1.8'}}>
              Your use of our services is also governed by our <Link to="/privacy" style={{color: '#3b82f6', textDecoration: 'underline'}}>Privacy Policy</Link>. 
              By using our services, you consent to the collection, use, and sharing of your information as described 
              in our Privacy Policy.
            </p>
          </div>

          <div style={{marginBottom: '3rem'}}>
            <h2 style={{fontSize: '1.8rem', fontWeight: '700', color: '#1e40af', marginBottom: '1rem'}}>
              12. Communication Consent
            </h2>
            <p style={{fontSize: '1rem', color: '#4b5563', lineHeight: '1.8'}}>
              By providing your contact information, you consent to receive communications from us via phone, email, 
              and SMS text messages regarding our services, your application support request, and related matters. You may 
              opt out of marketing communications at any time. See our <Link to="/sms-policy" style={{color: '#3b82f6', textDecoration: 'underline'}}>SMS Policy</Link> for 
              more information about text message communications.
            </p>
          </div>

          <div style={{marginBottom: '3rem'}}>
            <h2 style={{fontSize: '1.8rem', fontWeight: '700', color: '#1e40af', marginBottom: '1rem'}}>
              13. Termination
            </h2>
            <p style={{fontSize: '1rem', color: '#4b5563', lineHeight: '1.8'}}>
              We reserve the right to terminate or suspend your access to our services at any time, without notice, 
              for conduct that we believe violates these Terms of Service or is harmful to other users, us, or third 
              parties, or for any other reason. You may terminate your use of our services at any time by contacting us.
            </p>
          </div>

          <div style={{marginBottom: '3rem'}}>
            <h2 style={{fontSize: '1.8rem', fontWeight: '700', color: '#1e40af', marginBottom: '1rem'}}>
              14. Dispute Resolution and Arbitration
            </h2>
            <p style={{fontSize: '1rem', color: '#4b5563', lineHeight: '1.8', marginBottom: '1rem'}}>
              <strong>IMPORTANT:</strong> This section affects your legal rights. Please read carefully.
            </p>
            <p style={{fontSize: '1rem', color: '#4b5563', lineHeight: '1.8', marginBottom: '1rem'}}>
              Any dispute, claim, or controversy arising out of or relating to these Terms or our services shall be resolved 
              through binding arbitration under the rules of the American Arbitration Association (AAA). You agree to waive 
              your right to a jury trial and to participate in a class action lawsuit.
            </p>
            <ul style={{fontSize: '1rem', color: '#4b5563', lineHeight: '1.8', paddingLeft: '2rem'}}>
              <li>The arbitration will be conducted in English</li>
              <li>The arbitrator's decision will be final and binding</li>
              <li>Each party will bear their own costs and attorney fees</li>
              <li>Small claims court disputes are excluded from arbitration</li>
              <li>You have 30 days from first using our services to opt out of arbitration by emailing support@ursusconnects.com</li>
            </ul>
          </div>

          <div style={{marginBottom: '3rem'}}>
            <h2 style={{fontSize: '1.8rem', fontWeight: '700', color: '#1e40af', marginBottom: '1rem'}}>
              15. Class Action Waiver
            </h2>
            <p style={{fontSize: '1rem', color: '#4b5563', lineHeight: '1.8'}}>
              You agree that any dispute resolution proceedings will be conducted only on an individual basis and not in a 
              class, consolidated, or representative action. You waive your right to participate as a class representative 
              or class member in any class action proceeding.
            </p>
          </div>

          <div style={{marginBottom: '3rem'}}>
            <h2 style={{fontSize: '1.8rem', fontWeight: '700', color: '#1e40af', marginBottom: '1rem'}}>
              16. Governing Law
            </h2>
            <p style={{fontSize: '1rem', color: '#4b5563', lineHeight: '1.8'}}>
              These Terms of Service shall be governed by and construed in accordance with the laws of the United States 
              and the state in which Ursus Victor LLC is registered, without regard to conflict of law principles. 
              Any legal action must be brought within one (1) year of the event giving rise to the claim.
            </p>
          </div>

          <div style={{marginBottom: '3rem'}}>
            <h2 style={{fontSize: '1.8rem', fontWeight: '700', color: '#1e40af', marginBottom: '1rem'}}>
              17. Severability
            </h2>
            <p style={{fontSize: '1rem', color: '#4b5563', lineHeight: '1.8'}}>
              If any provision of these Terms is found to be unenforceable or invalid, that provision will be limited or 
              eliminated to the minimum extent necessary so that these Terms will otherwise remain in full force and effect 
              and enforceable.
            </p>
          </div>

          <div style={{marginBottom: '3rem'}}>
            <h2 style={{fontSize: '1.8rem', fontWeight: '700', color: '#1e40af', marginBottom: '1rem'}}>
              18. Entire Agreement
            </h2>
            <p style={{fontSize: '1rem', color: '#4b5563', lineHeight: '1.8'}}>
              These Terms of Service, along with our Privacy Policy and SMS Policy, constitute the entire agreement between 
              you and Ursus Victor LLC regarding the use of our services and supersede all prior agreements and understandings.
            </p>
          </div>

          <div style={{marginBottom: '3rem'}}>
            <h2 style={{fontSize: '1.8rem', fontWeight: '700', color: '#1e40af', marginBottom: '1rem'}}>
              19. Changes to Terms
            </h2>
            <p style={{fontSize: '1rem', color: '#4b5563', lineHeight: '1.8'}}>
              We reserve the right to modify these Terms of Service at any time. We will notify you of any material changes by 
              posting the new Terms of Service on this page, updating the "Last Updated" date, and providing notice via email 
              or SMS. Your continued use of our services after any changes constitutes acceptance of the new terms.
            </p>
          </div>

          <div style={{marginBottom: '3rem'}}>
            <h2 style={{fontSize: '1.8rem', fontWeight: '700', color: '#1e40af', marginBottom: '1rem'}}>
              20. Contact Information
            </h2>
            <p style={{fontSize: '1rem', color: '#4b5563', lineHeight: '1.8', marginBottom: '1rem'}}>
              If you have any questions about these Terms of Service, please contact us:
            </p>
            <div style={{
              background: '#dbeafe',
              padding: '1.5rem',
              borderRadius: '8px',
              borderLeft: '4px solid #3b82f6'
            }}>
              <p style={{fontSize: '1rem', color: '#1e40af', marginBottom: '0.5rem'}}>
                <strong>Ursus Victor LLC</strong>
              </p>
              <p style={{fontSize: '1rem', color: '#1e40af', marginBottom: '0.5rem'}}>
                Support: <a href="mailto:support@ursusconnects.com" style={{color: '#3b82f6'}}>support@ursusconnects.com</a>
              </p>
              <p style={{fontSize: '1rem', color: '#1e40af'}}>
                General Contact: <a href="mailto:info@ursusconnects.com" style={{color: '#3b82f6'}}>info@ursusconnects.com</a>
              </p>
            </div>
          </div>

          <div style={{
            background: '#dbeafe',
            padding: '2rem',
            borderRadius: '12px',
            border: '2px solid #3b82f6',
            textAlign: 'center'
          }}>
            <p style={{fontSize: '1rem', color: '#1e40af', lineHeight: '1.7'}}>
              <strong>By using our services, you acknowledge that you have read, understood, and agree to be bound 
              by these Terms of Service.</strong>
            </p>
          </div>

          <div style={{marginTop: '3rem', textAlign: 'center', display: 'flex', gap: '1rem', justifyContent: 'center', flexWrap: 'wrap'}}>
            <Link to="/privacy" style={{
              background: 'white',
              color: '#1e40af',
              padding: '1rem 2rem',
              borderRadius: '50px',
              fontWeight: '700',
              fontSize: '1rem',
              border: '2px solid #1e40af'
            }}>
              Privacy Policy
            </Link>
            <Link to="/sms-policy" style={{
              background: 'white',
              color: '#1e40af',
              padding: '1rem 2rem',
              borderRadius: '50px',
              fontWeight: '700',
              fontSize: '1rem',
              border: '2px solid #1e40af'
            }}>
              SMS Policy
            </Link>
            <Link to="/contact" style={{
              background: 'linear-gradient(135deg, #1e40af 0%, #3b82f6 100%)',
              color: 'white',
              padding: '1rem 2rem',
              borderRadius: '50px',
              fontWeight: '700',
              fontSize: '1rem'
            }}>
              Contact Us
            </Link>
          </div>
        </div>
      </section>
    </>
  );
};

export default Terms;
